import React from 'react';
import cn from 'classnames';

import styles from './UploadButton.module.scss';

const UploadButton = ({ imagesAmount }) => (
  <>
    {imagesAmount === 0 && (
      <div>
        <p className={cn(styles.bns3_uploader_text, styles.bns3_img_requirements_text)}>
          Only jpeg, jpg, png format up to 2MB, maximum 7 files
        </p>
        <p className={cn(styles.bns3_uploader_text, styles.bns3_img_instruction_text)}>
          Click or drag file to this area to upload
        </p>
      </div>
    )}

    {imagesAmount > 0 && <p className={styles.bns3_add_more_text}>&#43; Add more</p>}
  </>
);

export default UploadButton;
